module.exports = __webpack_public_path__ + "img/178.bfadb90a.jpg";